import React, { Component } from "react";
import "./footer.scss";
function footer(props) {
  return (
    <section className="footer">
      <div className="footerlinks">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6">
              <div className="addressHeading">
                <img src={require("../../images/Places.png")} alt="" />
                <h1>Address info</h1>
              </div>
              <div className="address">
                <p>
                  Office: Dnyandeep colony, Shriraj Bungalow, Yogiraj Park, Lane
                  No. 1, near Vidarbh Tadka hotel, Cummins college to Rajaram
                  bridge road, Hingne Budruk, Karve Nagar, <br />
                  Pin: 411 052
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="addressHeading">
                <h1>Contact Us</h1>
              </div>
              <div className="contactSection">
                <div className="contactDetails">
                  <img src={require("../../images/Messages.png")} alt="" />
                  <h4>info@logipool.in</h4>
                </div>
                <div className="contactDetails">
                  <img src={require("../../images/contact_Call.png")} alt="" />
                  <h4>9766316241 / 7887885052</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright">
        <p id="rights">©Logipool 2020  | All right reserved.</p>
        <p id="Designer"><a target="_blank" href="https://www.linkedin.com/in/ravimrk/">Designed by - Ravi Parmar</a></p>
      </div>
    </section>
  );
}
export default footer;
